import restClient from '../restClient';
export const CORPORATE_BENEFICIAL_OWNER_ACTORS_SUBMITTED = 'CORPORATE_BENEFICIAL_OWNER_ACTORS_SUBMITTED';
export const SUBMITTING_CORPORATE_BENEFICIAL_OWNER_ACTORS = 'SUBMITTING_CORPORATE_BENEFICIAL_OWNER_ACTORS';
export const CORPORATE_BENEFICIAL_SAVE_ERROR = 'CORPORATE_BENEFICIAL_SAVE_ERROR';
const corporateBeneficialOwnerActorsSubmitted = () => ({
  type: CORPORATE_BENEFICIAL_OWNER_ACTORS_SUBMITTED
});
const submittingCorporateBeneficialOwnerActors = () => ({
  type: SUBMITTING_CORPORATE_BENEFICIAL_OWNER_ACTORS
});
export const submitCorporateBeneficialOwnerActors = (corporateBeneficialOwnerActors, confirmation) => async dispatch => {
  dispatch(submittingCorporateBeneficialOwnerActors());
  try {
    await restClient.confirmCorporateActors({
      actors: {
        typeInfo: 'BENEFICIAL_OWNERS_V2',
        beneficialOwners: corporateBeneficialOwnerActors.beneficialOwners
      },
      answer: confirmation
    });
    dispatch(corporateBeneficialOwnerActorsSubmitted());
  } catch (error) {
    dispatch({
      type: CORPORATE_BENEFICIAL_SAVE_ERROR,
      error
    });
  }
};